// extracted by mini-css-extract-plugin
module.exports = {"instagramFeed":"InstagramFeed_instagramFeed__2qDhK","feedGrid":"InstagramFeed_feedGrid__1B82C","feedItem":"InstagramFeed_feedItem__3quuH"};